import {
  getClient
} from "./chunk-VUBUSKHM.mjs";

// src/react.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var ObservabilityBoundary = class extends React.Component {
  constructor() {
    super(...arguments);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    getClient()?.capture({
      level: "error",
      message: error.message,
      metadata: { stack: error.stack, componentStack: info.componentStack }
    });
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? /* @__PURE__ */ jsx("div", { style: { padding: 16, color: "#ef4444" }, children: "Something went wrong." });
    }
    return this.props.children;
  }
};
function withErrorBoundary(Component2, fallback) {
  return function Wrapped(props) {
    return /* @__PURE__ */ jsx(ObservabilityBoundary, { fallback, children: /* @__PURE__ */ jsx(Component2, { ...props }) });
  };
}
export {
  ObservabilityBoundary,
  withErrorBoundary
};
